import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { Container, Row, Col, Button, Form, Input } from 'reactstrap';
import Swiper from 'react-id-swiper';

import ClapprPlayer from '../ClapprPlayer/ClapprPlayer';

import * as vars from '../../constants/constants';
import { messages } from '../../constants/messages';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { addFavoriteChannel, addLikesChannels } from '../../actions/FavoriteActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { setHeaderTitle } from '../../actions/HeaderActions';
import { addChannelHistory } from '../../actions/HistoryActions';
import { console_log } from '../../utils/helper';
import { FormattedMessage } from 'react-intl';
import { config } from "../../constants/domainConfig";

// const msg = messages[config.lang];

class PlayChannel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRTL: false,
            data: {},
            isPlaying: false,
            playUrl: ''
        };

        this.getChannelCategories = this.getChannelCategories.bind(this);
        this.addRemoveFavorite = this.addRemoveFavorite.bind(this);
        this.channelFavorite = this.channelFavorite.bind(this);
        this.playChannel = this.playChannel.bind(this);
        this.goToPlay = this.goToPlay.bind(this);
        this.addHistoryChannel = this.addHistoryChannel.bind(this);
        this.addLike = this.addLike.bind(this);
        this.isChannelLiked = this.isChannelLiked.bind(this);
    }

    componentWillMount() {
        if (this.props.play.data.channel) {
            this.props.setHeaderTitle(this.props.play.data.channel.channelName);
            this.getChannelCategories(this.props.play.data.channel.channelId);
        }
        window.addEventListener('resize', () => this.toggleVideoDescription());
        window.addEventListener("resize", () => this.testBG());
    }

    shouldComponentUpdate() {
        return true;
    }

    componentDidUpdate() {
        this.toggleVideoDescription();
        this.testBG();
    }

    componentDidMount() {
        document.body.classList.add("play-page");
        window.scrollTo(0, 0);
        this.getChannel(this.props.play.data.channel.channelId);
        this.toggleVideoDescription();
        this.testBG();
    }

    toggleVideoDescription() {
        let videoDescButtonWrap = document.querySelector(".video__desc__btn-wrap");
        let videoDesc = document.querySelector(".video__desc");
        let videoDetailsWrap = document.querySelector(".video__details__wrap");
        let videoDescButton = document.querySelector(".video__desc__btn");
        let relatedSlide = document.querySelector(".related-slide");
        if (window.innerWidth <= 575) {
            if (videoDesc.scrollHeight > 75) {
                videoDescButtonWrap.style.opacity = "1";
                videoDescButtonWrap.style.height = "auto";
                videoDescButtonWrap.style.width = "100%";
            } else {
                videoDescButtonWrap.style.opacity = "0";
                videoDescButtonWrap.style.height = "0";
                videoDescButtonWrap.style.width = "0";
            }
        } else {
            videoDescButtonWrap.style.opacity = "0";
            videoDescButtonWrap.style.height = "0";
            videoDescButtonWrap.style.width = "0";
        }
        videoDetailsWrap.addEventListener("click", function (e) {
            if (e.target.className === "video__desc__btn") {
                videoDesc.classList.toggle("video__desc--more");
                if (videoDesc.classList.contains("video__desc--more")) {
                    videoDesc.style.maxHeight = videoDesc.scrollHeight + "px";
                    videoDescButton.textContent = "Show Less";
                } else {
                    videoDesc.style.maxHeight = "";
                    videoDescButton.textContent = "Show More";
                }
            }
        })
        relatedSlide.addEventListener("click", function (e) {
            if (e.target.className !== "heart-fill") {
                if (videoDesc.classList.contains("video__desc--more")) {
                    videoDesc.classList.toggle("video__desc--more");
                    videoDesc.style.maxHeight = "";
                    videoDescButton.textContent = "Show More";
                }
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.play.data.channel.channelId != nextProps.play.data.channel.channelId) {
            window.scrollTo(0, 0);
            this.getChannel(nextProps.play.data.channel.channelId);
            this.props.setHeaderTitle(nextProps.play.data.channel.channelName);
            this.getChannelCategories(nextProps.play.data.channel.channelId);
        }
        this.toggleVideoDescription();
    }

    componentWillUnmount() {
        document.body.classList.remove("play-page");
        window.removeEventListener('resize', () => this.toggleVideoDescription());
        window.removeEventListener("resize", () => this.testBG());
    }

    getChannelCategories(channelId) {
        this.setState({
            data: this.props.category.channels.find((channel) => channel.channelId == channelId)
        });
    }

    isChannelFavorite(channelId) {
        let indexOf = this.props.favorite.channels.findIndex((f) => {
            return f.channelId == channelId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    addRemoveFavorite(channel, event) {
        event.preventDefault();
        if (event.target.tagName == 'path' || event.target.classList.contains('favoriteClick')) {
            this.channelFavorite(channel);
        }
    }

    channelFavorite(channel) {
        let favoriteChannels = this.props.favorite.channels;
        let indexOf = favoriteChannels.findIndex((f) => {
            return f.channelId == channel.channelId;
        });

        let channelToBeUpdated = {
            channelId: channel.channelId,
            channelName: channel.channelName,
            channelLang: channel.channelLang,
            channelImage: channel.channelImage,
            channelLogo: channel.channelLogo,
            channelGrade: channel.channelGrade,
            channelStatus: channel.channelStatus,
            channelBaseline: channel.channelBaseline,
            isFavorite: true
        };

        if (indexOf == -1) {
            favoriteChannels.push(channelToBeUpdated);
            axios.post(vars.BASE_API_URL+"/favorites/channels", channelToBeUpdated)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].addToFavorites,
                        type: true
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            favoriteChannels.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL+"/favorites/channels/"+channelToBeUpdated.channelId)
                .then((response) => {
                    this.props.showMessage({
                        message: messages[config.lang].removeFromFavorites,
                        type: false
                    });
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addFavoriteChannel(favoriteChannels);
    }

    playChannel() {
        if(this.state.playUrl){
            this.setState({
                isPlaying: !this.state.isPlaying
            });
        this.addHistoryChannel(this.state.data);
       }
        
    }

    getChannel(channelId) {
        this.props.show();
        axios.get(vars.BASE_API_URL+"/getTVStreamingURL/"+channelId+"/WIFI")
            .then((response) => {
                this.setState({
                    playUrl: response.data.data.url
                });
                this.props.hide();
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
            });
    }

    goToPlay(data, event) {
        event.preventDefault();
        if (event.target.tagName == 'path' || event.target.classList.contains('favoriteClick')) {
            this.channelFavorite(data.channel);
        } else {
            this.props.getVideoOrChannelRelatedData(data);
        }
    }

    addHistoryChannel(channel) {
        let historyChannels = this.props.historyVideos.channels;
        let indexOf = historyChannels.findIndex((h) => {
            return h.channelId == channel.channelId;
        });

        let channelToBeUpdated = {
            channelId: channel.channelId,
            channelName: channel.channelName,
            channelLang: channel.channelLang,
            channelImage: channel.channelImage,
            channelLogo: channel.channelLogo,
            channelGrade: channel.channelGrade,
            channelStatus: channel.channelStatus,
            channelBaseline: channel.channelBaseline,
            isFavorite: true
        };

        if (indexOf == -1) {
            historyChannels.push(channelToBeUpdated);
            axios.post(vars.BASE_API_URL+"/history/channels", channelToBeUpdated)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addChannelHistory(historyChannels);
    }

    addLike(channel, event) {
        event.preventDefault();
        this.channelLike(channel);
    }

    channelLike(channel) {
        let likedChannels = this.props.favorite.channelsLiked;
        let indexOf = likedChannels.findIndex((f) => {
            return f.channelId == channel.channelId;
        });

        let channelToBeUpdated = {
            channelId: channel.channelId,
            channelName: channel.channelName,
            channelLang: channel.channelLang,
            channelImage: channel.channelImage,
            channelLogo: channel.channelLogo,
            channelGrade: channel.channelGrade,
            channelStatus: channel.channelStatus,
            channelBaseline: channel.channelBaseline
        };

        if (indexOf == -1) {
            likedChannels.push(channelToBeUpdated);
            axios.post(vars.BASE_API_URL+"/likes/channels", channelToBeUpdated)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        } else {
            likedChannels.splice(indexOf, 1);
            axios.delete(vars.BASE_API_URL+"/likes/channels/"+channelToBeUpdated.channelId)
                .then((response) => {
                    console_log(response);
                })
                .catch((error) => {
                    console_log(error);
                });
        }

        this.props.addLikesChannels(likedChannels);
    }

    isChannelLiked(channelId) {
        let indexOf = this.props.favorite.channelsLiked.findIndex((f) => {
            return f.channelId == channelId;
        });

        if (indexOf != -1) {
            return true;
        }
        return false;
    }

    testBG() {
        let testBG = document.querySelector(".test-bg");
        let playBG = document.querySelector(".play-bg");
        testBG.style.height = playBG.offsetHeight - 55 + "px";
    }

    render() {
        const videos = {
                slidesPerView: 'auto',
                speed: 400,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    767: {
                        direction: 'vertical',
                        slidesPerView: 'auto',
                        speed: 400,
                        spaceBetween: 0,
                        touchReleaseOnEdges: true,
                    }
                }
            },
            { isMobile } = this.state,
            heartIcon = '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
            heartIconNoBg = '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
            thumbsUpIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 456.814 456.814"><g class="thumbs-fill"><path d="M441.11 252.677c10.468-11.99 15.704-26.169 15.704-42.54 0-14.846-5.432-27.692-16.259-38.547-10.849-10.854-23.695-16.278-38.541-16.278h-79.082c.76-2.664 1.522-4.948 2.282-6.851.753-1.903 1.811-3.999 3.138-6.283 1.328-2.285 2.283-3.999 2.852-5.139 3.425-6.468 6.047-11.801 7.857-15.985 1.807-4.192 3.606-9.9 5.42-17.133 1.811-7.229 2.711-14.465 2.711-21.698 0-4.566-.055-8.281-.145-11.134-.089-2.855-.574-7.139-1.423-12.85-.862-5.708-2.006-10.467-3.43-14.272-1.43-3.806-3.716-8.092-6.851-12.847-3.142-4.764-6.947-8.613-11.424-11.565-4.476-2.95-10.184-5.424-17.131-7.421-6.954-1.999-14.801-2.998-23.562-2.998-4.948 0-9.227 1.809-12.847 5.426-3.806 3.806-7.047 8.564-9.709 14.272-2.666 5.711-4.523 10.66-5.571 14.849-1.047 4.187-2.238 9.994-3.565 17.415-1.719 7.998-2.998 13.752-3.86 17.273-.855 3.521-2.525 8.136-4.997 13.845-2.477 5.713-5.424 10.278-8.851 13.706-6.28 6.28-15.891 17.701-28.837 34.259-9.329 12.18-18.94 23.695-28.837 34.545-9.899 10.852-17.131 16.466-21.698 16.847-4.755.38-8.848 2.331-12.275 5.854-3.427 3.521-5.14 7.662-5.14 12.419v183.01c0 4.949 1.807 9.182 5.424 12.703 3.615 3.525 7.898 5.38 12.847 5.571 6.661.191 21.698 4.374 45.111 12.566 14.654 4.941 26.12 8.706 34.4 11.272 8.278 2.566 19.849 5.328 34.684 8.282 14.849 2.949 28.551 4.428 41.11 4.428h36.831c25.321-.38 44.061-7.806 56.247-22.268 11.036-13.135 15.697-30.361 13.99-51.679 7.422-7.042 12.565-15.984 15.416-26.836 3.231-11.604 3.231-22.74 0-33.397 8.754-11.611 12.847-24.649 12.272-39.115.024-6.097-1.4-13.328-4.261-21.706zM100.5 191.864H18.276c-4.952 0-9.235 1.809-12.851 5.426C1.809 200.905 0 205.188 0 210.137v182.732c0 4.942 1.809 9.227 5.426 12.847 3.619 3.611 7.902 5.421 12.851 5.421H100.5c4.948 0 9.229-1.81 12.847-5.421 3.616-3.62 5.424-7.904 5.424-12.847V210.137c0-4.949-1.809-9.231-5.424-12.847-3.617-3.618-7.898-5.426-12.847-5.426zM67.665 369.308c-3.616 3.521-7.898 5.281-12.847 5.281-5.14 0-9.471-1.76-12.99-5.281-3.521-3.521-5.281-7.85-5.281-12.99 0-4.948 1.759-9.232 5.281-12.847 3.52-3.617 7.85-5.428 12.99-5.428 4.949 0 9.231 1.811 12.847 5.428 3.617 3.614 5.426 7.898 5.426 12.847 0 5.14-1.805 9.468-5.426 12.99z"/></g></svg>',
            smartTvIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 72.6 72.6"><circle class="smart-tv-circle" cx="36.3" cy="36.3" r="34.3"/><path class="smart-tv-path" d="M48.9 29H31.2c-1.1 0-2-.9-2-2v-.8c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.1-.9 2-2 2zM49.1 38.9H31.4c-1.1 0-2-.9-2-2V36c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.2-.9 2.1-2 2.1zM48.9 48.9H31.2c-1.1 0-2-.9-2-2V46c0-1.1.9-2 2-2h17.7c1.1 0 2 .9 2 2v.8c0 1.2-.9 2.1-2 2.1zM26.4 25.9l-4.1-2.7c-.4-.2-.9 0-.9.5V29c0 .4.5.7.9.5l4.1-2.7c.3-.1.3-.6 0-.9zM26.4 36.5l-4.1-2.7c-.4-.2-.9 0-.9.5v5.3c0 .4.5.7.9.5l4.1-2.7c.3-.2.3-.7 0-.9zM26.4 45.7L22.3 43c-.4-.2-.9 0-.9.5v5.3c0 .4.5.7.9.5l4.1-2.7c.3-.2.3-.7 0-.9z"/></svg>';

        let channel = this.state.data;
        return (
            <section className="play py-0">
                <div className="test-bg"></div>
                <Row>
                    <Col xs="12">
                        {channel?
                            <div className={(this.state.isRTL? "play-bg ar": "play-bg") + (this.state.isPlaying? " video-active": "")}>
                                <div className="video">
                                    {(this.state.isPlaying && this.state.playUrl != '')?
                                        <ClapprPlayer source={this.state.playUrl} poster={channel.channelImage ? vars.BASE_URL+"uploads/"+channel.channelImage : "./img/thumbnail-2.jpg"}
                                        data={{rid: this.props.access.uid, vname: channel.channelName, vcategory: ""}}
                                         />
                                        :
                                        <div>
                                            <div className="play__thumb-wrap">
                                                <img className="play__thumb" src={channel.channelImage ? vars.BASE_URL+"uploads/"+channel.channelImage : "./img/thumbnail-2.jpg"} alt={channel.channelName} />
                                            </div>
                                            <div className="play__btn-wrap">
                                                <a className="common-btn common-btn--red play__btn" href="javascript:void(0);" onClick={this.playChannel}>
                                                    <span className="play__btn-inner">
                                                        <i className="fa fa-play" aria-hidden="true"></i>
                                                        <span className="play__btn-text">
                                                            <FormattedMessage id="play"
                                                                defaultMessage="Play"
                                                            />
                                                        </span>
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    }
                                    <div className="video__details__wrap">
                                        <div className="video__details">
                                            <div className="video__head">
                                                <h3 className="video__title">{channel.channelName}</h3>
                                                <div className="video__head__ratings">
                                                    <div className="video__smart">
                                                        <a href={(this.state.playUrl)?"/#/all/"+channel.channelId:"javascript:void(0)"}>
                                                            <span className="no-bg no-animation smart-tv-label" dangerouslySetInnerHTML={{ __html: smartTvIcon }} />
                                                            <span className="video__star__text">SmartTV</span>
                                                        </a>
                                                    </div>
                                                    <div className="video__fav favoriteClick" onClick={this.addRemoveFavorite.bind(this, channel)}>
                                                        <input className="icon-toggle favoriteClick" id="two" type="checkbox" checked={this.isChannelFavorite(channel.channelId)} onChange={() => {}}/>
                                                        <label className="icon-toggle-label favoriteClick" htmlFor="two">
                                                            <span className="no-bg favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                        </label>
                                                        <span className="video__star__text">Watch Later</span>
                                                    </div>
                                                    <div className="video__rate" onClick={this.addLike.bind(this, channel)}>
                                                        <input className="icon-toggle" id="three" type="checkbox" checked={this.isChannelLiked(channel.channelId)} onChange={() => {}}/>
                                                        <label className="icon-toggle-label" htmlFor="three">
                                                            <span className="no-bg" dangerouslySetInnerHTML={{ __html: thumbsUpIcon }} />
                                                        </label>
                                                        <span className="video__star__text">
                                                            <FormattedMessage id="rate"
                                                                defaultMessage="Rate"
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="video__sub-head">
                                                <div className="imdb">
                                                    <img className="imdb__image" src={channel.channelLogo} alt={channel.channelName} />
                                                    {/*<span className="imdb__rating">{channel.channelBaseline}</span>*/}
                                                </div>
                                                <div className="video__extras">
                                                    <ul className="list-unstyled video__extras__list">
                                                        <li className="video__extras__item"><span className="video__extras__text">{channel.channelGrade}</span></li>
                                                        <li className="video__extras__item"><span className="video__extras__text">{channel.channelLang.toUpperCase()}</span></li>
                                                        <li className="video__extras__item"><span className="video__extras__text"><i className="fa fa-feed" aria-hidden="true"></i>
                                                            <FormattedMessage id="liveNow"
                                                                defaultMessage="Live Now"
                                                            />
                                                        </span></li>
                                                    </ul>
                                                    <div className="video__genre">
                                                        <img src="./img/tag-icon.png" alt="genre" />
                                                        <span className="video__genre__text">
                                                        {channel.channelCategories?
                                                            channel.channelCategories.map((category) => {
                                                                return category.category.name
                                                            }).join(", ")
                                                            : ''
                                                        }
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className={this.state.isRTL? "video__desc text-reverse" : "video__desc"}>{channel.channelBaseline}</p>
                                            <div className="video__desc__btn-wrap">
                                                <button className="video__desc__btn">
                                                    <FormattedMessage id="showMore"
                                                        defaultMessage="Show More"
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ''
                        }
                    </Col>
                </Row>
                <div className="related-outer-wrapper">
                    <Container fluid>
                        <Row>
                            <Col xs="12">
                                {channel.channelCategories?
                                    <div className="related-wrap">
                                        <div className="category-head related-top-links">
                                            <h3 className="primary-text">Related Channels</h3>
                                            <div className="category-head__favorite">
                                                <h3>Autoplay</h3>
                                                <label className="switch">
                                                    <input type="checkbox" className="switch__checkbox" />
                                                    <span className="switch__slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div>
                                            {channel.channelCategories.length > 0 ?
                                                <Swiper {...videos} rebuildOnUpdate={false} shouldSwiperUpdate={true}>
                                                    {this.props.category.channels.map((c) => {
                                                        if (c.channelId != channel.channelId) {
                                                            return (
                                                                <div key={c.channelId} className="related-slide" onClick={this.goToPlay.bind(this, {channel: c})}>
                                                                    <div className="channels-thumb channels-thumb--genre">
                                                                        <div className="channels-image channels-image--genre no-radius">
                                                                            <img className="channels-thumb__image channels-thumb__image--genre rounded-0" src={c.channelImage ? vars.BASE_URL+"uploads/"+c.channelImage : "./img/thumbnail-2.jpg"} alt={c.channelName} />
                                                                            <img className="channels-thumb__icon" src={c.channelLogo} alt={c.channelName} />
                                                                        </div>
                                                                        <div className="channels-thumb__fav">
                                                                            <input className="icon-toggle favoriteClick" id={'tv-'+c.channelId} type="checkbox" checked={this.isChannelFavorite(c.channelId)} onChange={() => {}} />
                                                                            <label className="icon-toggle-label favoriteClick" htmlFor={'tv-'+c.channelId}>
                                                                                <span className="favoriteClick"><i className="fa fa-star favoriteClick" aria-hidden="true"></i></span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="channels-thumb__details channels-thumb__details--related">
                                                                        <div className="channels-thumb__inner channels-thumb__inner--related">
                                                                            <div className="channels-thumb__name channels-thumb__name--related">
                                                                                {c.channelName}
                                                                                <span className="channel-show__name"><img className="related-live-icon" src="./img/live-red.svg" />{c.channelBaseline}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </Swiper>
                                                : ''}
                                        </div>
                                    </div>
                                    :''
                                }
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getVideoOrChannelRelatedData,
        addFavoriteChannel,
        showMessage,
        setHeaderTitle,
        addChannelHistory,
        addLikesChannels
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayChannel);


// WEBPACK FOOTER //
// ./src/components/Play/PlayChannel.js